import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import FontAwesome from 'react-fontawesome';

import './styles.css'

export default class ShareSocialLinks extends Component{
    render(){
        return(
            <div className="float-md-right">
                <a href="https://www.facebook.com/kickavenueid/" target="_blank" className="share-social" title="Share it!">
                    <FontAwesome name="facebook"/>
                </a>
                {/* <a href="#" className="share-social" onClick={(e)=>e.preventDefault()} title="Share it!">
                    <FontAwesome name="twitter"/>
                </a> */}
                <a href="https://www.instagram.com/kick.avenue/" target="_blank" className="share-social" title="Share it!" >
                    <FontAwesome name="instagram"/>
                </a>
                {/* <a href="#" className="share-social" onClick={(e)=>e.preventDefault()} title="Share it!">
                    <FontAwesome name="google-plus"/>
                </a> */}
                {/* <a href="mailto:info@kickavenue.com" className="share-social" title="Share it!">
                    <FontAwesome name="envelope"/>
                </a> */}
                <a href="#" className="share-social" onClick={this.props.onModalLine} title="Share it!">
                    <i className="icon_line"></i>
                </a>
            </div>
        )
    }
}